interface TopbarProps {
  chatTitle?: string
  msgCount?: number
  onMobileMenuClick?: () => void
}

export function Topbar({ chatTitle, msgCount = 0, onMobileMenuClick }: TopbarProps) {
  return (
    <div className="topbar">
      <div className="topbar-left">
        {onMobileMenuClick && (
          <button
            className="topbar-hamburger"
            onClick={onMobileMenuClick}
            aria-label="Open navigation"
          >
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
              <rect x="2" y="4" width="14" height="1.5" rx="0.75" fill="currentColor"/>
              <rect x="2" y="8.25" width="14" height="1.5" rx="0.75" fill="currentColor"/>
              <rect x="2" y="12.5" width="14" height="1.5" rx="0.75" fill="currentColor"/>
            </svg>
          </button>
        )}
        {chatTitle && <span className="topbar-title">{chatTitle}</span>}
      </div>
      {msgCount > 40 && (
        <span className={`msg-counter${msgCount >= 50 ? ' warn' : ''}`} aria-live="polite">
          {msgCount}/80 messages
        </span>
      )}
    </div>
  )
}
